





























































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {Message} from "@/entity/Message";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {Strophe} from "strophe.js";
import XHeader from "@/views/KeShangAdmin/XHeader.vue";
import Footer from "@/views/KeShangAdmin/Footer.vue";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Customer} from "@/entity/Customer";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {CollectCompany} from "@/entity/CollectCompany";
import {CustomerDto} from "@/dto/CustomerDto";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {MessageJiGuangUserBody} from "@/entity/MessageJiGuangUserBody";
import {JiGuangDto} from "@/dto/JiGuangDto";
import {ajax} from "jquery";
import {BaseStore} from "@/store/BaseStore";

@Component({
  components: {Footer, XHeader},
})

export default class EbyChatPage extends Vue {
  message1 = '';
  message = new Message();
  connection!: Strophe.Connection;
  @Prop({default: ''})
  jid!: string
  @Prop({default: ''})
  name!: string
  // jid = this.$route.params.jid;
  // name = this.$route.params.name;
  tab1 = 'mails';
  static messages: Message[] = [];
  messages = EbyChatPage.messages;
  su = SecurityUtils;
  sendJid = this.su.getLoginUser().username + '@rtc1';
  user = this.su.getLoginUser();
  files: string[] = [];
  fab2 = false;

  selectFile() {
    if (this.$refs.selectFiles != null) {
      (this.$refs.selectFiles as any).click()
    }
  }

  openWenJianUrl(url: string) {
    window.location.href = url;
  }

  upload(f: any) {
    console.log('111')
    const formData = new FormData();
    formData.append("file", f.target.files[0]);
    ajax({
      type: 'post',
      url: "https://fileserver.yong-gang.cn/api/uploadFile",
      dataType: 'json',
      data: formData,
      processData: false,   // jQuery不要去处理发送的数据
      contentType: false,   // jQuery不要去设置Content-Type请求头
      success: (data) => {
        this.sendd(data.data);
      }
    })
  }

  async send() {
    if (this.message1 != '') {
      this.connection = XmppUtils.connection;
      this.xmppSendMsg();
      const messageJiGuangUserBody = new MessageJiGuangUserBody();
      messageJiGuangUserBody.message = this.message1;
      messageJiGuangUserBody.jidUsername = this.jid.substring(0, 11);
      messageJiGuangUserBody.name = this.su.getLoginUser().name;
      try {
        await JiGuangDto.sendMessage(messageJiGuangUserBody);
      } catch (e) {
        console.log(e);
      }
      const message = new Message();
      message.mes = this.message1;
      message.sendJid = this.sendJid;
      message.receiveJid = this.jid;
      const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
      if (item != null && item.length > 2) {
        this.messages = JSON.parse(item);
        this.messages.push(message);
        EbyChatPage.messages.push(message);
        this.messages = EbyChatPage.messages;
        localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(this.messages));
      } else {
        const messages: Message[] = [];
        messages.push(message);
        EbyChatPage.messages.push(message);
        this.messages = EbyChatPage.messages;
        localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(messages));
      }
      this.message1 = '';
      const a = document.querySelector("#gunDongTiao > div > div.q-layout-container.overflow-hidden > div > div")
      if (a !== null) {
        setTimeout(()=>{
          a.scrollTo({
            top: 9999,
            left: 0
          })
        },500)

      }
      // setTimeout(()=>{
      // },1000)


    }
  }



  async sendd(data: any) {
    if (data) {

      const messageJiGuangUserBody = new MessageJiGuangUserBody();
      messageJiGuangUserBody.message = '文件';
      messageJiGuangUserBody.jidUsername = this.jid.substring(0, 11);
      messageJiGuangUserBody.name = this.su.getLoginUser().name;
      try {
        await JiGuangDto.sendMessage(messageJiGuangUserBody);
      } catch (e) {
        console.log(e);
      }
      console.log(data)
      const message = new Message();

      message.sendJid = this.sendJid;
      message.filePreviewUrl = data.filePreviewUrl;
      message.fileDownloadUrl = data.fileDownloadUrl;
      message.receiveJid = this.jid;
      if (data.fileName) {


        // const a = data.fileName.indexOf('.');
        // message.type = data.fileName.substring(a + 1, data.fileName.length);
        const  a = data.fileName.split('.')
        message.type = a[a.length-1]
        let type = '';
        if (message.type === 'png' || message.type === 'jpg' || message.type==='PNG' || message.type==='JPG'){
          type = '[图片]'
        } else {
          type = data.fileName;
        }
        message.mes = type;
        this.connection = XmppUtils.connection;
        const msg = $msg({
          to: this.jid,
          // from: this.jid,
          type: 'chat',
          xmlns: "jabber:client",
          types: a[a.length-1],
          filePreviewUrl: data.filePreviewUrl,
          fileDownloadUrl: data.fileDownloadUrl
        }).c("body", null, type);
        this.connection.send(msg.tree());
        this.connection.send($pres().tree());
        const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
        if (item != null && item.length > 2) {
          this.messages = JSON.parse(item);
          this.messages.push(message);
          EbyChatPage.messages.push(message);
          this.messages = EbyChatPage.messages;
          localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(this.messages));
        } else {
          const messages: Message[] = [];
          messages.push(message);
          EbyChatPage.messages.push(message);
          this.messages = EbyChatPage.messages;
          localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(messages));
        }
      }
    }
  }

  xmppSendMsg() {
    const msg = $msg({
      to: this.jid,
      // from: this.jid,
      type: 'chat',
      xmlns: "jabber:client"
    }).c("body", null, this.message1);
    this.connection.send(msg.tree());
    this.connection.send($pres().tree());
  }

  fanhui() {
    // this.$router.push("/keShangSelect2")
    // history.pushState(null, 'popstate', location.href);
    // window.addEventListener("popstate", e => {
    //   history.pushState(null, '', location.href);
    // });
    getModule(BaseStore).setYgMessage('homePage')
    // console.log(111)

  }

  keShangSelect() {
    this.$router.push({name: 'KeShangSelect'});
  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }

  mounted() {
    this.findAll()
    this.findAllCompanyName();
    const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
    if (item != null && item.length > 2) {
      this.messages = EbyChatPage.messages = JSON.parse(item);
    }
  }

  private customers: Customer[] = [];
  customer = new Customer();
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);

  rightDrawerOpen = true;
  drawer = false;
  tab = 'home';
  collectCompany = new CollectCompany()


  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  saveCompany() {
    localStorage.setItem("name", this.cs.currentCustomer.name)
  }

  companyName() {
    const item: string | null = localStorage.getItem("name");
    if (item == null) {
      return "home"
    }
    return item;
  }

  get userName() {
    return this.ls.loginUser.username
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }


  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
  }

  handleClick(c: Customer) {
    getModule(CustomerStore).setCurrentCustomer(c);
    this.rightDrawerOpen = !this.rightDrawerOpen;

    this.saveCompany();
    // const id = c.id + '';
    // this.$router.push({name: 'KeShangMain', params: {id: id}});
  }

  // get customerName() {
  //   return this.cs.currentCustomer.name;
  // }

  async findAllCompanyName() {
    const id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany();
    this.collectCompany = await CollectCompanyDto.findById(id)
    // console.log(this.collectCompany)
    // this.collectCompany.companyName = this.module.currentCustomer.name
  }

  get customerName() {

    // const  id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany()
    // collectName.userId = id;
    // this.collectCompany  =  await CollectCompanyDto.findById( id)


    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }
}
